import { render, staticRenderFns } from "./ChooseHousingCompanyView.vue?vue&type=template&id=2bb08805&"
import script from "./ChooseHousingCompanyView.vue?vue&type=script&lang=ts&"
export * from "./ChooseHousingCompanyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports